import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["maxLength", "value"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react/jsx-one-expression-per-line */


import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getRem, typographyCaption } from "./../../core";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledCharacterCount = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    margin-top: ", ";\n    margin-left: auto;\n    padding: 0 ", " 0 ", ";\n  "])), typographyCaption(theme), theme.size.spacing.small.value, getRem(12), theme.size.spacing.small.value);
});

var InputCharacterCount = function InputCharacterCount(_ref2) {
  var maxLength = _ref2.maxLength,
      value = _ref2.value,
      other = _objectWithoutProperties(_ref2, _excluded);

  var currentCharacterCount = value ? value.length : 0;
  return /*#__PURE__*/_jsxs(StyledCharacterCount, _objectSpread(_objectSpread({}, other), {}, {
    children: [currentCharacterCount, "/", maxLength]
  }));
};

InputCharacterCount.displayName = "InputCharacterCount";
InputCharacterCount.propTypes = {
  /** Maximum amount of characters input field can have */
  maxLength: PropTypes.number.isRequired,

  /** Current value of the input field */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
export { InputCharacterCount };